import React from 'react'
import { useTranslation } from 'react-i18next'
import FormRow from '../../FormRow'
import TagsInput from '../TagsInput'

interface NotificationEmailsFieldProps {
  value: string[]
  onChange: (next: string[]) => void
}

function NotificationEmailsField({ value, onChange }: NotificationEmailsFieldProps) {
  const { t } = useTranslation()

  return (
    <FormRow title={t('customers.notificationEmails')}>
      <TagsInput
        value={value}
        placeholder={t('customers.notificationEmailsHint')}
        onChange={onChange}
      />
    </FormRow>
  )
}

export default NotificationEmailsField
